import { CODE_MESSAGE } from "../../assets/settings/settinsrouters"

export const validateEmptyFields = (formValues, optionalFields = []) => {
  return Object.entries(formValues)
    .filter(([key, value]) => ( value === null || value === undefined || value === "") && !optionalFields.includes(key) )
    .length === 0;
}

export const GetMessageInfo = (code, detail) =>{
  let response = null;
  if (CODE_MESSAGE){
      response = code + ' - ' + detail;
  }
  else{
      response= detail;
  }

  return response;
}